import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "horizontal-fieldset" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("legend", null, "Axis of Rotation:", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("fieldset", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "x",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.axisOfRotation) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
          onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('updatePreview')))
        }, null, 544), [
          [_vModelRadio, _ctx.axisOfRotation]
        ]),
        _createTextVNode(" X ")
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "y",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.axisOfRotation) = $event)),
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
          onFocusout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('updatePreview')))
        }, null, 544), [
          [_vModelRadio, _ctx.axisOfRotation]
        ]),
        _createTextVNode(" Y ")
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          value: "z",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.axisOfRotation) = $event)),
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
          onFocusout: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('updatePreview')))
        }, null, 544), [
          [_vModelRadio, _ctx.axisOfRotation]
        ]),
        _createTextVNode(" Z ")
      ])
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Horizontal Resolution (mm/px): "),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hRes) = $event)),
        onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
        onFocusout: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('updatePreview')))
      }, null, 544), [
        [_vModelText, _ctx.hRes]
      ])
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Vertical Resolution (mm/px): "),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vRes) = $event)),
        onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
        onFocusout: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('updatePreview')))
      }, null, 544), [
        [_vModelText, _ctx.vRes]
      ])
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Arc (degrees): " + _toDisplayString(_ctx.arc) + " ", 1),
      _withDirectives(_createElementVNode("input", {
        type: "range",
        min: "1",
        max: "360",
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.arc) = $event)),
        onInput: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.recalculate && _ctx.recalculate(...args))),
        onFocusout: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('updatePreview')))
      }, null, 544), [
        [_vModelText, _ctx.arc]
      ])
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Inner Radius (mm): "),
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: _ctx.round(_ctx.radius, 4)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Inner Arc Length (mm): "),
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: _ctx.round(_ctx.arcLength, 4)
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Inner Width (mm): "),
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: _ctx.round(_ctx.width, 4)
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Inner Depth (mm): "),
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: _ctx.round(_ctx.depth, 4)
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("label", null, [
      _createTextVNode(" Height (mm): "),
      _createElementVNode("input", {
        type: "number",
        disabled: "",
        value: _ctx.round(_ctx.height, 4)
      }, null, 8, _hoisted_7)
    ])
  ], 64))
}